import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TicketTable from "../../components/support/TicketTable";
import TicketFilters from "../../components/support/TicketFilters";
import { supportTicketService } from "../../services/supportTicketService";
import type { SupportTicket } from "../../types/supportTicket";
import "../../assets/supportTickets.css";

const SubscriberSupportTickets: React.FC = () => {
  const [tickets, setTickets] = useState<SupportTicket[]>([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    priority: "",
    department: "",
  });

  const fetchTickets = async () => {
    try {
      setLoading(true);
      const res = await supportTicketService.getSubscriberTickets({
        page: 1,
        limit: 10,
        ...filters,
      });
      setTickets(res.tickets || []);
    } catch (error) {
      console.error("Failed to fetch subscriber tickets", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, [filters]);

  const handleChange = (key: string, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleReset = () => {
    setFilters({
      search: "",
      status: "",
      priority: "",
      department: "",
    });
  };

  return (
    <>
      <div id="home-p" className="home-p pages-head9 text-center">
        <div className="container"></div>
      </div>

      <div className="support-page-wrap">
        <div className="support-card">
          <div className="support-card-header">
            <h2>
              <i className="fa fa-life-ring" /> Support
            </h2>

            <Link to="/support/create" className="open-ticket-btn">
              Open Support Ticket
            </Link>
          </div>

          <TicketFilters
            filters={filters}
            onChange={handleChange}
            onReset={handleReset}
          />

          {loading ? (
            <div className="ticket-empty-box">Loading tickets...</div>
          ) : (
            <TicketTable tickets={tickets} detailBasePath="/support/tickets" />
          )}
        </div>
      </div>
    </>
  );
};

export default SubscriberSupportTickets;
